// sets default values, overridden by appsettings.json, if it exists
import { ReportRoute } from './report-route';
export class AppSettings {
    useAuthentication = true;
    useStaticReportData = false;
    apiUrl = 'http://localhost:50020';
    identityUrl = 'https://dv1-identity.cap-hpi.com';
    redirectUri = 'http://localhost:4200';
    clientId: string;
    scope: string;
    helpUrl: string;
    editorialUrl: string;
    userManagementUrl: string;
    productName: string;
    reportRouting: Array<ReportRoute>;
    reportCreationRequestTimeout: number = 15000;
    longRunningRequestTimeout : number = 120000;
    reportRefreshInterval = 600;
    reportPageSize = 3;
}



// WEBPACK FOOTER //
// ./src/app/settings/app.settings.ts